module.exports = __webpack_public_path__ + "static/media/add-activity-banner-disabled.03ddd0a0.png";